import { Dispatch, FC, Fragment, memo, NamedExoticComponent, SetStateAction } from 'react'
import { Box, Stack, Heading, List, Center, Flex, FlexProps } from '@chakra-ui/react'

import { CustomIconProps } from 'types'
import SidebarWithViewsItem from './components/SidebarWithViewsItem'

export type SidebarSubItemsForViews = {
  name: string
  pageKey: string
  Icon: NamedExoticComponent<CustomIconProps>
  permission?: string[]
  subItems?: SubSubItems[]
}

export type SubSubItems = {
  name: string
  pageKey: string
  Icon: NamedExoticComponent<CustomIconProps>
}

export type SidebarItemsForViews = {
  id: number
  name?: string
  subItems: SidebarSubItemsForViews[]
}

export type SiderbarWithViewCommonProps = {
  view: string
  setView: Dispatch<SetStateAction<string>>
}

type Props = SiderbarWithViewCommonProps & {
  flexProps?: FlexProps
  sidebarItems: SidebarItemsForViews[]
  customHeight?: string | string[]
}

const SidebarWithViews: FC<Props> = ({ flexProps, sidebarItems, customHeight, ...commonProps }) => {
  return (
    <Flex
      as="aside"
      // height={['100%', '100%', 'calc(100vh - 50px - 82px - 8px)']}
      height={customHeight ?? ['100%', 'calc(100vh - 225px)']}
      overflowY="auto"
      minWidth={300}
      bg="light"
      align="start"
      flexDirection="column"
      justifyContent="space-between"
      transition="ease-in-out .2s"
      rounded="md"
      {...flexProps}
    >
      <Box w="full" p={4} overflow="auto">
        {sidebarItems.map(({ id, name, subItems }) => (
          <Stack key={id} w={'full'}>
            {subItems.length > 0 && (
              <>
                {name && (
                  <Center w="full" pt={2} gap={0} transition={'all 0.2s 0.2s'}>
                    <Heading
                      color="gray.400"
                      fontWeight="medium"
                      textTransform="uppercase"
                      textAlign="left"
                      fontSize="sm"
                      opacity={1}
                    >
                      {name}
                    </Heading>
                  </Center>
                )}

                <List width="full" mb={2}>
                  {subItems.map((item) => {
                    return (
                      <Fragment key={item.name}>
                        <SidebarWithViewsItem {...item} {...commonProps} />
                      </Fragment>
                    )
                  })}
                </List>
              </>
            )}
          </Stack>
        ))}
      </Box>
    </Flex>
  )
}

export default memo(SidebarWithViews)
